import { Component, NgZone, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { LocalNotificationService } from 'src/app/_provider/notifications/local-notification.service';
import { NotificationService } from 'src/app/_provider/notifications/notification.service';
import { ZeitenService } from 'src/app/_provider/zeiten.service';


@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {


  public isModal: boolean = false
  public loading: boolean = true

  constructor(
    public notificationSrv: NotificationService,
    private timeSrv: ZeitenService,
    private localNotificationSrv: LocalNotificationService,
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private ngZone: NgZone
  ) { }

  async ngOnInit() {
    await this.notificationSrv.loadUserSettings()
    this.ngZone.run(() => this.loading = false)
  } 

  public async close(){
    if(this.isModal) await this.modalCtrl.dismiss()
    else await this.navCtrl.pop()
  }

  public async toggleWorkingTime(){
    await this.notificationSrv.toggleWorkingTime()
    if(this.notificationSrv.workingTimes) await this.localNotificationSrv.checkOngoingNotifications(this.timeSrv.timeTickett)
    else await this.localNotificationSrv.cancelAllNotifications()
  }


 
}
